// @flow strict
// eslint-disable-next-line import/prefer-default-export
export { default as pluralize } from './pluralize';
